import { Flex, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { ModalBase } from '../../../../../components/ModalBase'
import { SwitchCmp } from '../../../../../components/SwitchCmp'

interface iModalProps {
  recomendacoes: number
  isOpen: boolean
  permitirIA?: boolean
  semPDIAtual?: boolean
  onRequestClose: () => void
  onCreate: (opcao: string, comIA?: boolean) => void
}

export const ModalPDI: React.FC<iModalProps> = ({ isOpen, recomendacoes, permitirIA, semPDIAtual, onCreate, onRequestClose }) => {
  const [ComIA, setComIA] = useState(false)

  return (
        <ModalBase Width='52.688rem'
            onClose={onRequestClose}
            isOpen={isOpen}
            Titulo='Desenvolvimento do PDI'
        >
            <Flex padding={'0 1rem'}>
                <Text
                    fontSize={'.875rem'}
                    fontWeight={'500'}
                >
                    Para esse novo ciclo você irá trabalhar {recomendacoes} competências.
                    <br />
                    {semPDIAtual
                      ? 'Neste momento você pode criar o PDI com base nessas competências.'
                      : 'Neste momento você deve selecionar se deseja iniciar um novo ciclo de acompanhamento, gerando um novo PDI, ou se deseja adicionar essas competências no PDI atual.'}
                </Text>
            </Flex>
            {permitirIA && <Flex padding={'1rem 1rem 0'}>
                <SwitchCmp value={ComIA} OnChange={setComIA} legendaDireita='Gerar recomendações com IA' />
            </Flex>}
            <Flex gap={'.5rem'} justifyContent={'center'} padding='1rem 0'>
                <ButtonCmp
                    onClick={() => onCreate('1', ComIA)}
                    VarColor='Rosa'
                >{semPDIAtual ? 'Criar PDI' : 'Iniciar um novo PDI '}</ButtonCmp>

                {!semPDIAtual && <ButtonCmp
                    onClick={() => onCreate('2', ComIA)}
                    VarColor='Green2'
                >Continuar no PDI atual (recomendado)</ButtonCmp>}
            </Flex>
        </ModalBase>
  )
}
